/**
 * Labstep
 *
 * @module screens/ExperimentWorkflow/Index/LeftPane
 * @desc ExperimentWorkflow Index LeftPane
 */

import { ExperimentWorkflowFilterPane } from 'labstep-web/components/ExperimentWorkflow/Filter/Pane';
import { FolderPane } from 'labstep-web/components/Folder/Pane';
import { LayoutLeftPane } from 'labstep-web/components/Layout/LeftPane';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { FolderType } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { ExperimentWorkflowIndexTableTimelineLeftPaneProps } from './types';

export const ExperimentWorkflowIndexTableTimelineLeftPane: React.FC<
  ExperimentWorkflowIndexTableTimelineLeftPaneProps
> = ({ disableShortcuts }) => (
  <LayoutLeftPane>
    <ParamsStateContextProvider value={{}}>
      <FolderPane folderType={FolderType.experiment_workflow} />
      {!disableShortcuts && <ExperimentWorkflowFilterPane />}
    </ParamsStateContextProvider>
  </LayoutLeftPane>
);
